import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from "../../../../store/actionCreators/dialog";
import { getCurrentClub } from "../../../../store/selectors";

const UnionMenu = ({isOpened}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [isVisible, setIsVisible] = useState(false);
    useEffect(()=>{
        if(isOpened) {
            setIsVisible(isOpened)
        }
    },[isOpened]);
    const openUpgradeDialog = title => {
        setIsVisible(false);
        dispatch(openDialog(title, { clubId: clubData.clubId}));
    }
    const openUnionDialog = action => {
        setIsVisible(false);
        dispatch(openDialog('unionNotice', {action}));
    };

    const clubData = useSelector(getCurrentClub);
    const isAllowforUnionOps = clubData.level >= 2 && clubData.levelExpDays > 0;

    return (
        <div className={`mainDropdown  ${isVisible || isOpened ? 'visible':''}`}>
            <div className={`menuList`}>
                <span onClick={() => isAllowforUnionOps ? openUnionDialog('join'): openUpgradeDialog('upgradeToJoin')} className={'menuItem'}>{t('joinUnion')}</span>
                <div className="separatorLine" />
                <span onClick={() => isAllowforUnionOps ? openUnionDialog('create'): openUpgradeDialog('upgradeToCreate')} className={'menuItem'}>{t('createUnion')}</span>
            </div>
            <div className={`transparentMask`} onClick={() => setIsVisible(false)} />
        </div>
    )
};

export default UnionMenu;
